import React, { Component } from 'react';

import ListView from '../Common/ListView.react';
import LabelFormDialog from "./LabelFormDialog";

import { LabelDialogs } from '../../constants/Dialogs';
import DialogActions from "../../actions/DialogActionCreator";
import LabelActions from '../../actions/LabelActionCreator';
import LabelStore from '../../stores/LabelStore';
import LabelListItem from './LabelListItem';


class LabelList extends Component {

    constructor (props) {
        super(props);
        this.state = {
            labels: [],
            count: 0,
            page: 0,
            limit: 25
        };
        this.onChange = this.onChange.bind(this);
    }

    componentDidMount() {
        this.listener = LabelStore.addListener(this.onChange);
        LabelActions.getAll();
    }

    componentWillUnmount() {
        this.listener.remove();
    }

    render() {
        return (
            <ListView
                title="Labels"
                newEntityAction={() => DialogActions.open(LabelDialogs.LABEL)}
                items={this.state.labels}
                itemDecorator={LabelListItem}
            >
                <LabelFormDialog/>
            </ListView>
        );
    }

    onChange() {
        this.setState({labels: LabelStore.getAll()});
    }
}

export default LabelList;
